module.exports = __webpack_public_path__ + "img/fist-talos.a36f682c.jpg";